<template>
  <div id="app">
    <!-- 蝯曹?撠汗??-->
    <!-- ?餃?蝙?函蝡? LoginHeader -->
    <LoginHeader v-if="$route.path === '/login'" />
    <!-- ?嗡?頝舐雿輻 v2 AppHeader嚗?亥???Pinia Store -->
    <AppHeaderV2 v-else />

    <main class="main-content">
      <router-view></router-view>
    </main>

    <footer v-if="$route.path !== '/login'" class="app-footer">
      <!-- ?偏?批捆 -->
    </footer>
  </div>
</template>

<script>
import { ref, onMounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuth } from '@/composables/useAuth'
import AppHeaderV2 from '@/components/AppHeader.vue'
import LoginHeader from '@/components/LoginHeader.vue'

export default {
  name: 'App',
  components: {
    AppHeaderV2,
    LoginHeader
  },
  setup() {
    const route = useRoute()
    const { userStore, userInitial, logout } = useAuth()
    const hasNotifications = ref(false)
    const mobileMenuOpen = ref(false)

    const applyRouteBodyClass = () => {
      document.body.classList.add('v2-route')
    }

    const toggleMobileMenu = () => {
      mobileMenuOpen.value = !mobileMenuOpen.value
    }

    const closeMobileMenu = () => {
      mobileMenuOpen.value = false
    }

    watch(
      () => route.fullPath,
      () => {
        mobileMenuOpen.value = false
        applyRouteBodyClass()
      }
    )

    onMounted(async () => {
      if (route.path !== '/auth/callback') {
        await userStore.initializeSession()
      }
      applyRouteBodyClass()
    })

    return {
      userStore,
      userInitial,
      hasNotifications,
      mobileMenuOpen,
      toggleMobileMenu,
      closeMobileMenu,
      logout
    }
  }
}
</script>

<style>
/* ?典?璅???蔭 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  min-height: 100vh;
}

/* ?啗身閮楝?曹蝙?函摨?*/
body.v2-route {
  background: #ffffff;
}

#app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

/* 撠汗?見撘?*/
.app-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}

.header-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 2rem;
}

.brand {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.brand:hover {
  transform: scale(1.05);
}

.brand-icon {
  font-size: 1.8rem;
}

.brand-text {
  font-size: 1.2rem;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.nav-menu {
  display: flex;
  gap: 0.5rem;
  flex: 1;
  justify-content: center;
}

.nav-link {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.2rem;
  color: #666;
  text-decoration: none;
  border-radius: 12px;
  transition: all 0.3s ease;
  font-weight: 500;
  position: relative;
}

.nav-link:hover {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
  transform: translateY(-2px);
}

.nav-link.active {
  /* 蝘駁蝝怨瞍詨惜?嚗?箇摨?*/
  background: #ffffff;
  color: #333;
  box-shadow: none;
}

.nav-icon {
  font-size: 1.1rem;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 1.5rem;
}

.notification-btn {
  position: relative;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
  transition: transform 0.3s ease;
}

.notification-btn:hover {
  transform: scale(1.1);
}

.notification-icon {
  font-size: 1.5rem;
}

.notification-badge {
  position: absolute;
  top: 0;
  right: 0;
  background: #ff4757;
  color: white;
  border-radius: 10px;
  padding: 0.1rem 0.4rem;
  font-size: 0.7rem;
  font-weight: 600;
}

/* ?餃?? */
.login-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.6rem 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  text-decoration: none;
  border-radius: 25px;
  font-weight: 600;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4);
}

.login-icon {
  font-size: 1.2rem;
}

/* 雿輻???*/
.user-menu {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 1rem;
  background: rgba(102, 126, 234, 0.1);
  border-radius: 25px;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
}

.user-menu:hover {
  background: rgba(102, 126, 234, 0.2);
  transform: translateY(-2px);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.2rem;
  overflow: hidden;
}

.user-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-name {
  font-weight: 500;
  color: #333;
}

/* ???詨?? */
.mobile-menu-toggle {
  display: none;
  flex-direction: column;
  gap: 4px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.5rem;
}

.mobile-menu-toggle span {
  width: 25px;
  height: 3px;
  background: #667eea;
  border-radius: 3px;
  transition: all 0.3s ease;
}

/* ???詨 */
.mobile-menu {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  pointer-events: none;
}

.mobile-menu.active {
  pointer-events: all;
}

.mobile-menu-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.mobile-menu.active .mobile-menu-overlay {
  opacity: 1;
}

.mobile-menu-content {
  position: absolute;
  top: 0;
  right: -300px;
  width: 300px;
  height: 100%;
  background: white;
  transition: right 0.3s ease;
  overflow-y: auto;
  box-shadow: -2px 0 20px rgba(0, 0, 0, 0.1);
}

.mobile-menu.active .mobile-menu-content {
  right: 0;
}

.mobile-user-info {
  padding: 2rem 1.5rem;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.user-avatar-large {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.8rem;
  font-weight: 600;
  overflow: hidden;
}

.user-avatar-large img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.user-details .user-name {
  font-weight: 600;
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
  color: white;
}

.user-email {
  font-size: 0.9rem;
  opacity: 0.9;
}

.mobile-nav {
  padding: 1rem 0;
}

.mobile-nav-link {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;
  color: #333;
  text-decoration: none;
  transition: background 0.3s ease;
}

.mobile-nav-link:hover,
.mobile-nav-link.router-link-active {
  background: rgba(102, 126, 234, 0.1);
  color: #667eea;
}

.mobile-nav-divider {
  height: 1px;
  background: #e0e0e0;
  margin: 0.5rem 0;
}

/* 銝餃摰孵? */
.main-content {
  flex: 1;
  width: 100%;
  position: relative;
  padding-top: 0;
}

/* ?偏 */
.app-footer {
  background: rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  color: white;
  margin-top: auto;
  padding: 3rem 0 1rem;
}

.footer-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}

.footer-section h4 {
  margin-bottom: 1rem;
  font-size: 1.1rem;
}

.footer-section p {
  opacity: 0.9;
  line-height: 1.6;
}

.footer-section ul {
  list-style: none;
}

.footer-section ul li {
  margin-bottom: 0.5rem;
}

.footer-section a {
  color: white;
  text-decoration: none;
  opacity: 0.9;
  transition: opacity 0.3s ease;
}

.footer-section a:hover {
  opacity: 1;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-links a {
  font-size: 1.5rem;
  transition: transform 0.3s ease;
}

.social-links a:hover {
  transform: scale(1.2);
}

.footer-bottom {
  text-align: center;
  padding: 1.5rem 0 0;
  margin-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  opacity: 0.8;
}

/* ?踵?撘身閮?*/
@media (max-width: 968px) {
  .nav-menu {
    display: none;
  }
  
  .header-actions {
    display: none;
  }
  
  .mobile-menu-toggle {
    display: flex;
  }
  
  .header-container {
    padding: 0 1rem;
  }
}

@media (max-width: 640px) {
  .brand-text {
    font-size: 1rem;
  }
  
  .footer-container {
    grid-template-columns: 1fr;
    text-align: center;
  }
  
  .social-links {
    justify-content: center;
  }
}

/* ??? */
@keyframes slideDown {
  from {
    transform: translateY(-100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.app-header {
  animation: slideDown 0.5s ease;
}
</style>

